import { useLang } from "@/i18n";
import { photos } from "@/data/site";
import { PageHero } from "@/components/site/PageHero";
import { ReviewsSection } from "@/components/site/ReviewsSection";
import { CtaBanner } from "@/components/site/CtaBanner";
import { SEO } from "@/components/site/SEO";

export default function Recensioni() {
  const { t } = useLang();
  return (
    <>
      <SEO title={t.pages.recensioni.seo} description={t.pages.recensioni.desc} path="/recensioni" />
      <PageHero image={photos.marinaPorto} eyebrow={t.pages.recensioni.eyebrow} title={t.pages.recensioni.title} testid="recensioni-hero" />
      <ReviewsSection all />
      <CtaBanner />
    </>
  );
}
